module.exports = __webpack_public_path__ + "Images/icon.png";


//////////////////
// WEBPACK FOOTER
// ./Images/icon.png
// module id = 1867
// module chunks = 2